import scaffolderPlugin, { formFieldsApiRef } from '@backstage/plugin-scaffolder/alpha';
import {
  ScaffolderPage,
  scaffolderPlugin as legacyScaffolderPlugin,
} from '@backstage/plugin-scaffolder';
import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';

const customTagSelectField = FormFieldBlueprint.make({
  name: 'CustomTagSelect',
  params: {
    field: async () => {
      const { CustomTagSelect } = await import(
        '../scaffolder/CustomTagSelect/CustomTagSelectFieldExtension'
      );
      return createFormField({
        name: 'CustomTagSelect',
        component: CustomTagSelect,
      });
    },
  },
});

const userInfoField = FormFieldBlueprint.make({
  name: 'UserInfoField',
  params: {
    field: async () => {
      const { UserInfoField } = await import(
        '../scaffolder/UserInfoField/UserInfoFieldExtension'
      );
      return createFormField({
        name: 'UserInfoField',
        component: UserInfoField,
      });
    },
  },
});

const markdownEditorField = FormFieldBlueprint.make({
  name: 'MarkdownEditorField',
  params: {
    field: async () => {
      const { MarkdownEditorField } = await import(
        '../scaffolder/MarkdownEditorField/MarkdownEditorFieldExtension'
      );
      return createFormField({
        name: 'MarkdownEditorField',
        component: MarkdownEditorField,
      });
    },
  },
});

const adrPreviewField = FormFieldBlueprint.make({
  name: 'AdrPreviewField',
  params: {
    field: async () => {
      const { AdrPreviewField } = await import(
        '../scaffolder/AdrPreviewField/AdrPreviewFieldExtension'
      );
      return createFormField({
        name: 'AdrPreviewField',
        component: AdrPreviewField,
      });
    },
  },
});

const dateField = FormFieldBlueprint.make({
  name: 'DateField',
  params: {
    field: async () => {
      const { DateField } = await import(
        '../scaffolder/DateField/DateFieldExtension'
      );
      return createFormField({
        name: 'DateField',
        component: DateField,
      });
    },
  },
});

const orgDivisionPickerField = FormFieldBlueprint.make({
  name: 'OrgDivisionPicker',
  params: {
    field: async () => {
      const { OrgDivisionPicker } = await import(
        '../scaffolder/OrgDivisionPicker/OrgDivisionPickerField'
      );
      return createFormField({
        name: 'OrgDivisionPicker',
        component: OrgDivisionPicker,
      });
    },
  },
});

const orgPlatformPickerField = FormFieldBlueprint.make({
  name: 'OrgPlatformPicker',
  params: {
    field: async () => {
      const { OrgPlatformPicker } = await import(
        '../scaffolder/OrgPlatformPicker/OrgPlatformPickerField'
      );
      return createFormField({
        name: 'OrgPlatformPicker',
        component: OrgPlatformPicker,
      });
    },
  },
});

/** Custom template list and scaffolder field extensions on the native page. */
const scaffolderFeature = scaffolderPlugin.withOverrides({
  extensions: [
    customTagSelectField,
    userInfoField,
    markdownEditorField,
    adrPreviewField,
    dateField,
    orgDivisionPickerField,
    orgPlatformPickerField,
    scaffolderPlugin.getExtension('page:scaffolder').override({
      factory(originalFactory, { apis, inputs }) {
        const formFieldsApi = apis.get(formFieldsApiRef);
        return originalFactory({
          params: {
            path: '/create',
            noHeader: true,
            routeRef: legacyScaffolderPlugin.routes.root,
            loader: async () => {
              const apiFormFields = (await formFieldsApi?.loadFormFields()) ?? [];
              const formFieldLoaders = inputs.formFields.map(output =>
                output.get(FormFieldBlueprint.dataRefs.formFieldLoader),
              );
              const loadedFormFields = await Promise.all(
                formFieldLoaders.map(loader => loader()),
              );
              const formFields = [...apiFormFields, ...loadedFormFields];

              const { CustomTemplateListPage } = await import(
                '../components/scaffolder/CustomTemplateListPage'
              );
              const { TemplateGoldenPathLink } = await import(
                '../components/scaffolder/TemplateGoldenPathLink'
              );
              const { TwoColumn } = await import('../scaffolder/TwoColumnLayout');

              const ScaffolderPageAny = ScaffolderPage as any;
              return (
                <>
                  <TemplateGoldenPathLink />
                  <ScaffolderPageAny
                    formFields={formFields}
                    // Apply the TwoColumn React component directly as the default
                    // ObjectFieldTemplate — no ScaffolderLayouts extension needed.
                    formProps={{
                      uiSchema: {
                        'ui:ObjectFieldTemplate': TwoColumn,
                      },
                    }}
                    components={{
                      EXPERIMENTAL_TemplateListPageComponent:
                        CustomTemplateListPage,
                    }}
                  />
                </>
              );
            },
          },
        });
      },
    }),
  ],
});

export default scaffolderFeature;
